import { render, staticRenderFns } from "./ResultReportBaseInformationForm.vue?vue&type=template&id=38650bcb&"
import script from "./ResultReportBaseInformationForm.vue?vue&type=script&lang=ts&"
export * from "./ResultReportBaseInformationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports